export const projects = [
    {
        id: "autoglobal",
        testId: "portfolio-card-autoglobal",
        name: "Auto Global Group",
        url: "https://autoglobalgroup.eu",
        live: true,
        image: "/projects/autoglobal.png",
        gallery: null,
        tags: ["Automotive", "Živé filtrovanie", "Dopytové formuláre"],
        sk: {
            status: "Živý projekt",
            category: "Autobazár & dovoz vozidiel",
            description:
                "Oficiálna platforma pre predaj, výkup a dovoz prémiových vozidiel. Okamžité filtrovanie ponuky, kalkulačka dovozu a priame dopytové formuláre.",
        },
        en: {
            status: "Live project",
            category: "Car dealership & import",
            description:
                "Official platform for sales, buyback and import of premium vehicles. Instant stock filtering, import calculator and direct lead forms.",
        },
    },
    {
        id: "elephant-diner",
        testId: "portfolio-card-elephant-diner",
        name: "Elephant DINER",
        url: "https://us-eu-frontend.preview.emergentagent.com",
        live: false,
        image: "/projects/elephant.png",
        gallery: [
            "/projects/gallery/elephant-1.jpg",
            "/projects/gallery/elephant-2.jpg",
            "/projects/gallery/elephant-3.jpg",
            "/projects/gallery/elephant-4.jpg",
            "/projects/gallery/elephant-5.jpg",
            "/projects/gallery/elephant-6.jpg",
        ],
        tags: ["Digitálne menu", "Rezervácie", "Gastronómia"],
        sk: {
            status: "Dizajnový návrh · Rača",
            category: "Gastronómia & americký diner",
            description:
                "Autorský návrh pre ikonický americký diner. Retro atmosféra 50. rokov pretavená do moderného online menu a rezervácií.",
        },
        en: {
            status: "Design concept · Rača",
            category: "Hospitality & American diner",
            description:
                "Bespoke concept for an iconic American diner. 1950s nostalgia distilled into a fast digital menu and booking experience.",
        },
    },
    {
        id: "lunulus",
        testId: "portfolio-card-lunulus",
        name: "Lunulus",
        url: "https://lunulus-deploy.preview.emergentagent.com",
        live: false,
        image: "/projects/lunulus.png",
        gallery: [
            "/projects/gallery/lunulus-1.jpg",
            "/projects/gallery/lunulus-2.jpg",
            "/projects/gallery/lunulus-3.jpg",
            "/projects/gallery/lunulus-4.jpg",
            "/projects/gallery/lunulus-5.jpg",
            "/projects/gallery/lunulus-6.jpg",
        ],
        tags: ["Viacjazyčný web", "Recruiting", "Editorial dizajn"],
        sk: {
            status: "Web v portfóliu štúdia",
            category: "Personálna agentúra · gastronómia",
            description:
                "Viacjazyčný web pre personálnu agentúru zameranú na gastronómiu. Férové podmienky bez provízií, dôraz na transparentnosť a dôveru.",
        },
        en: {
            status: "Studio portfolio site",
            category: "Hospitality recruitment agency",
            description:
                "Multilingual website for a hospitality recruitment agency. Fair terms without commissions, with a focus on transparency and trust.",
        },
    },
    {
        id: "masazne-studio",
        testId: "portfolio-card-masazne-studio",
        name: "Masážne štúdio Martina",
        url: "https://masazne-studio.preview.emergentagent.com",
        live: false,
        image: "/projects/masazne.png",
        gallery: [
            "/projects/gallery/masazne-1.jpg",
            "/projects/gallery/masazne-2.jpg",
            "/projects/gallery/masazne-3.jpg",
            "/projects/gallery/masazne-4.jpg",
            "/projects/gallery/masazne-5.jpg",
            "/projects/gallery/masazne-6.jpg",
        ],
        tags: ["Rezervácie", "Cenník", "Wellness UX"],
        sk: {
            status: "Dizajnový návrh · Čadca",
            category: "Wellness & masážne štúdio",
            description:
                "Pokojný, prémiový web pre masážne štúdio — prehľad služieb, orientačný cenník a jednoduchá rezervácia termínu na pár klikov.",
        },
        en: {
            status: "Design concept · Čadca",
            category: "Wellness & massage studio",
            description:
                "A calm, premium website for a massage studio — clear services, indicative pricing and effortless appointment booking.",
        },
    },
];
